import http from '../../utils/http'
import { TAGS } from 'actions/tags'
import Vue from 'vue'

const state = {
	tags: []
}

const getters = {
	getTags: state => state.tags
}

const actions = {
	[TAGS]: ({commit, dispatch}) => {
		return http.get('/company/tags')
			.then((resp) => {
				commit(TAGS, resp.data)
			})
			.catch(err => {
				console.log(err)
				Vue.rollbar.error('TAGS', err)
			})
	}
}

const mutations = {
	[TAGS]: (state, resp) => {
		state.tags = resp
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
